import { render } from "./PostDetailsPage.vue?vue&type=template&id=1c530078&scoped=true"
import script from "./PostDetailsPage.vue?vue&type=script&lang=js"
export * from "./PostDetailsPage.vue?vue&type=script&lang=js"

import "./PostDetailsPage.vue?vue&type=style&index=0&id=1c530078&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c530078"]])

export default __exports__